module.exports = __webpack_public_path__ + "public/files/img/logo.3ca8e32e.png";